export enum FeatureGroup {
  MANAGE_ENTERPRISE = 1,
  MANAGE_USER = 2,
  MANAGE_DOCUMENT = 3,
  MANAGE_CUSTOMER = 4,
  CREATE_SIDE_DOCUMENT = 5,
  RECEIVE_SIDE_DOCUMENT = 6,
  SIGN = 7,
  DIGITAL_CONTRACT = 10,
  STANDARDIZATION_EMPLOYMENT_CONTRACT = 14,
  PERSONAL_PROFILE_MANAGE = 15,
}

export const DEFAULT_FULL_PERMISSION_LIST = [0, 1, 2, 3, 4, 401, 402, 403, 404, 405, 5, 6, 7, 12, 14, 15];
